import { __css } from '@fluentui/react-components';

import type { Session } from '../api/session';
import Header from './Header';
import VideoStream, { type StreamMessage } from './VideoStream';

const useStyles = __css({"root":{"mc9l5x":"f22iagw","Beiy3e4":"f1vx9l62","xawz":0,"Bh6795r":0,"Bnnss6s":0,"fkmc3a":"fz7g6wx","sshi5w":"fprs0cq","B68tc82":0,"Bmxbyg5":0,"Bpg54ce":"f1a3p1vp"},"content":{"mc9l5x":"f22iagw","xawz":0,"Bh6795r":0,"Bnnss6s":0,"fkmc3a":"fz7g6wx","sshi5w":"fprs0cq","B68tc82":0,"Bmxbyg5":0,"Bpg54ce":"f1a3p1vp","qhf8xq":"f10pi13n"}});

interface StreamViewProps {
  session: Session;
  onEndSession: () => void;
  onMessage?: (message: StreamMessage) => void;
}

const StreamView = ({ session, onEndSession, onMessage }: StreamViewProps) => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <Header expiration={session.expiration} onEndSession={onEndSession} />
      <div className={styles.content}>
        <VideoStream session={session} onMessage={onMessage} />
      </div>
    </div>
  );
};

export default StreamView;


import "/usr/local/jenkins/workspace/BI_bi-frontend_2.2.3/src/components/StreamView.griffel.css";